import {
    configureStore,
} from '@reduxjs/toolkit'
import { commonMiddleware, commonReducer } from 'stores/slices/common'
import { userMiddleware, userReducer } from 'stores/slices/user'

/**
 * @see https://www.valentinog.com/blog/redux/#modern-redux-with-redux-toolkit
 */
const store = configureStore({
    reducer: {
        user: userReducer,
        common: commonReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(...userMiddleware, ...commonMiddleware),
})

export default store
